import { useEffect, useState } from "react";

// Redux
import { useDispatch } from "react-redux";

import { getSpecificUser } from "../../../redux/features/Settings/Management/Users";

// Components
import SourceDestinationAccountDetail from "../../_utils/TransactionCommonComponents/SourceDestinationAccountDetail";
import CommonLayout from "../../_utils/CommonLayout";
import { getSpecificFieldForceAccount } from "../../../redux/features/accounts/fieldForceAccount";
import Loader from "../../Loader/Index";
import ICONS from "../../../assets/Icons";

const FieldForceRequestAccount = (props) => {
  const dispatch = useDispatch();

  //  useState
  const [loading, setLoading] = useState(
    props?.txnPayLoad?.beneAccountId?.length ? false : true,
  );
  const [isError, setIsError] = useState(false);

  const [beneAccountId, setBeneAccountId] = useState(
    props?.txnPayLoad?.beneAccountId ? props?.txnPayLoad?.beneAccountId : null,
  );

  //  Callbacks
  const fetch = async () => {
    if (!props?.txnPayLoad?.beneAccountId?.length) {
      const id = JSON.parse(sessionStorage.getItem("response"))?.employees?.id;
      let response = await dispatch(getSpecificUser(id));

      if (response?.payload?.employees?.[0]?.field_force_account) {
        let data = await dispatch(
          getSpecificFieldForceAccount({
            id: response?.payload?.employees?.[0]?.field_force_account,
          }),
        );

        handleAccountSelection(
          data?.payload?.field_force_accounts?.[0]?.name,
          data?.payload?.field_force_accounts?.[0]?.bank_acc_no,
          data?.payload?.field_force_accounts?.[0]?.ifsc_code,
          data?.payload?.field_force_accounts?.[0]?.ifsc_code,
          data?.payload?.field_force_accounts?.[0]?.category_ids
            ?.map((category) => category.category_name)
            .join(),
          data?.payload?.field_force_accounts?.[0]?.pan_no,
          data?.payload?.field_force_accounts?.[0]?.id,
          data?.payload?.field_force_accounts?.[0]?.labels,
        );

        setLoading(false);
      } else {
        setIsError(true);
        setLoading(false);
      }
    }
  };

  //  useEffect
  useEffect(() => {
    fetch();
  }, []);

  const handleCloseModal = () => {
    props?.setIsModalOpen(false);
  };

  const handleAccountSelection = (
    accountName,
    accountNumber,
    ifsc,
    bankLogo,
    category,
    panNo,
    beneAccountId,
    labels,
  ) => {
    const categoriesArray = category?.split(",");
    props?.setCategory(categoriesArray);
    // setAccountName(accountName);
    // setBankLogo(bankLogo);
    setBeneAccountId(beneAccountId);
    // setPanNumber(panNo);
    props?.setLabelsAcc(labels);

    props?.setTxnPayLoad((prev) => ({
      ...prev,
      bankAccountName: accountName,
      beneAccountId: beneAccountId,
      bankAccountIFSC: ifsc,
      bankAccountNo: accountNumber,
      bankLogo: bankLogo,
      pan: panNo,
      labels: labels,
      mergeCategory: null,
    }));
    props?.setAmountInWords("");
    handleCloseModal();
  };

  return (
    <>
      {loading ? (
        <div className="h-full w-full flex justify-center items-center">
          <Loader />
        </div>
      ) : (
        <div className="w-width-full Qlg:px-padding-base px-padding-md Qsmd:pt-padding-lg pt-padding-md">
          <CommonLayout>
            <div
              className={`w-width-full lg:max-w-[var(--create-box-width)] items-stretch`}
            >
              {isError ? (
                <div className="p-padding-md flex items-center bg-emphasis rounded-border-radius-md mb-margin-md">
                  <div className="flex items-center gap-x-gap-sm">
                    <img
                      className="h-icon-md w-icon-md flex-shrink-0"
                      src={ICONS?.ERROR_WITH_WHITE_CIRCLE}
                      alt="error"
                    />
                    <p className="text-text-primary text-font-sm font-normal">
                      No field force account is linked to your user. Link an
                      account to create a request.
                    </p>
                  </div>
                </div>
              ) : null}
              <SourceDestinationAccountDetail
                type="destination"
                flow="beneficiary"
                modalOpen={props?.isModalOpen}
                setModalOpen={props?.setIsModalOpen}
                txnPayLoad={props.txnPayLoad}
                setTxnPayLoad={props.setTxnPayLoad}
                shouldShowAssociatedAccounts={false}
                handleOnAccountSelection={handleAccountSelection}
                isDisabled={isError ? true : false}
                isEditDisabled={true}
                isFieldforce={true}
                page="confirm"
              />
            </div>
          </CommonLayout>

          <div className="h-mobile-create-header w-width-full Qmd:hidden block mt-margin-md"></div>
        </div>
      )}
    </>
  );
};

export default FieldForceRequestAccount;
